module.exports = __webpack_public_path__ + "img/av (3).253aad99.png";